module.exports = __webpack_public_path__ + "static/newMap-dbddf5f96b7c6c87a76d410f9a7eb7f4.png";